import { Col } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { CustomBorderTitle } from "../../../../Constants/Constants";
import { dynamicNumber } from "../../../../Utils";

const CustomBorder = () => {
  return (
    <Col xxl="3" sm="6">
      <div className="border-wrapper h-100 alert-light-light dark-helper">
        <H5 className="mb-3">{CustomBorderTitle}</H5>
        <div className="helper-common-box">
          <div className="helper-box b-r-0 bg-light border"></div>
          <span>{".b-r-0"}</span>
        </div>
        {dynamicNumber(10).map((item, index) => (
          <div className="helper-common-box" key={index}>
            <div className={`helper-box bg-light border b-r-${item}`} />
            <span>{`b-r-${item}`}</span>
          </div>
        ))}
      </div>
    </Col>
  );
};
export default CustomBorder;
